// src/components/steps/HospitalsStep.js
import React, { useState, useEffect } from "react";
import { fetchHospitalsNearby } from "../../services/api";

const HospitalsStep = ({ cep, onCount }) => {
  const [hospitals, setHospitals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!cep) return;

    const fetchList = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchHospitalsNearby(cep);
        setHospitals(data);
        onCount(data.length > 0);
      } catch {
        setError("Erro ao buscar hospitais. Tente novamente.");
        setHospitals([]);
        onCount(false);
      } finally {
        setLoading(false);
      }
    };

    fetchList();
  }, [cep, onCount]);

  if (loading) {
    return (
      <div className="flex justify-center mt-6">
        <div className="w-8 h-8 border-4 border-[#E5E7EB] border-t-[#2A4DD0] rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return <p className="text-red-500 text-center mt-6">{error}</p>;
  }

  if (!hospitals.length) {
    return (
      <p className="text-gray-600 text-center mt-6">
        Desculpe-nos, não encontramos unidades no CEP informado.
      </p>
    );
  }

  return (
    <div className="mt-6 w-full overflow-x-auto">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Hospitais próximos
      </h3>
      <div className="flex space-x-4">
        {hospitals.map((hospital) => (
          <div
            key={hospital.id}
            className="min-w-[220px] bg-white rounded-lg shadow p-4 flex-shrink-0"
          >
            <img
              src="/newlogo.png"
              alt="Logo Hapivida"
              className="w-16 h-auto mb-2 mx-auto"
            />
            <div className="text-center">
              <h4 className="font-semibold text-base text-black">
                {hospital.name}
              </h4>
              <p className="text-sm text-gray-600">{hospital.adress}</p>
              <p className="text-sm text-gray-600">{hospital.type}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HospitalsStep;
